import { MutationTuple } from '@apollo/client';
import { QueryResponses } from './responses';
import { kScheduling } from './kScheduling.enum';
import { logAmplitude } from '../analytics/analytics';
import { useStores } from '../../hooks/useStores';

const requests = [
  kScheduling.regionFailRequest,
  kScheduling.languageFailRequest,
];
const unhappyStates = [
  kScheduling.regionFailRequest,
  kScheduling.languageFailRequest,
  kScheduling.appointmentError,
  kScheduling.serviceAlreadyBooked,
];
export const handleEndOfSchedulerSurvey = (
  rootStore: ReturnType<typeof useStores>,
  feedbackWithJson: MutationTuple<any, any>['0'],
) => {
  const responses = rootStore.treeNav.choices.consumeFinalised();
  const survey = new QueryResponses(responses || []);

  // analytics
  const failReason = unhappyStates.find(k => survey.has(k)) || 'unknown';
  if (survey.has(kScheduling.appointmentCreated)) {
    const topics = survey.getMultiWording(kScheduling.chooseTopics);
    logAmplitude('WPO Appointment Booked', topics ? {topics: topics} : {});
  } else {
    logAmplitude('WPO Appointment Error', {reason: failReason});
  }

  // send feedback
  for (const request of requests) {
    const requestText = survey.getText(request);
    if (survey.has(request) && requestText) {
      console.log('sending feedback', request, requestText);
      feedbackWithJson({
        variables: {
          feedback: JSON.stringify({
            from: 'Unhappy case in wpo scheduling survey',
            'Company name': rootStore?.user?.user?.companyName,
            questionKey: request,
            Comment: requestText
          })
        }
      });
    }
  }

};